import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyBtzoYfSN2qJc2FQDHLIw6m0eTlXyhoMIo",
    authDomain: "ddabroad-dae69.firebaseapp.com",
    projectId: "ddabroad-dae69",
    storageBucket: "ddabroad-dae69.firebasestorage.app",
    messagingSenderId: "33721035101",
    appId: "1:33721035101:web:29f3d9471c0df45da960b4"
  };
  
  const app = initializeApp(firebaseConfig);
  const db = getFirestore(app); // Initialize Firestore
  
  export { db }; // Export the Firestore instance



// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyBtzoYfSN2qJc2FQDHLIw6m0eTlXyhoMIo",
//   authDomain: "ddabroad-dae69.firebaseapp.com",
//   projectId: "ddabroad-dae69",
//   storageBucket: "ddabroad-dae69.firebasestorage.app",
//   messagingSenderId: "33721035101",
//   appId: "1:33721035101:web:29f3d9471c0df45da960b4",
//   measurementId: "G-J9V2SWL900"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);